// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:26
import { QueryValueElement_abstract } from './../../abstract/SagaBase/Objects/QueryValueElement_abstract';
export class QueryValueElement extends QueryValueElement_abstract {}
